import { api } from '../../api';

export const fetchBookById = async (bookId: number) => {
  const url = `/v1/books/${bookId}`;
  const response = await api.get(url);
  const { book } = response.data;
  return book;
};
